import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Router } from "@angular/router";
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { FuseConfigService } from '../../../../../../core/services/config.service';
import { fuseAnimations } from '../../../../../../core/animations';
import { ProNavigationModel } from '../../../../../../navigation/proNavigation.model';
import { FuseNavigationService } from '../../../../../../core/components/navigation/navigation.service';
import { FuseTranslationLoaderService } from '../../../../../../core/services/translation-loader.service';
import { locale as navigationEnglish } from '../../../../../../navigation/i18n/en';
import { locale as navigationTurkish } from '../../../../../../navigation/i18n/tr';

//Local file
import { toastMsg, spekwo, register } from '../../../utils/index';

//Query files
import { UserQueryService, RolesQueryService } from '../../../gql-query-mutation/index';

/** Service file */
import { AuthService } from '../../auth.service';

/** Local component */
import { ToastComponent } from '../../../../../../core/components/toast/toast.component';

@Component({
    selector: 'register-form',
    templateUrl: './register-from.component.html',
    styleUrls: ['./register-from.component.scss'],
    animations: fuseAnimations
})

export class RegisterationFormComponent implements OnInit {

    registerForm: FormGroup;

    registerFormErrors: any;
    userUID: any;
    action: any;
    allEmails: Array<any> = [];

    isResults: boolean = false;
    enableClose: boolean = false;

    toastMsg = toastMsg;
    spekwoValues = spekwo;
    registerValues = register;


    constructor(
        private fuseConfig: FuseConfigService,
        private formBuilder: FormBuilder,
        public snackBar: MatSnackBar,
        private router: Router,
        private fuseNavigationService: FuseNavigationService,
        private translate: TranslateService,
        private translationLoader: FuseTranslationLoaderService,
        /**Query service */
        public userQueryService: UserQueryService,
        public rolesQueryService: RolesQueryService,
        /** Service file */
        public authService: AuthService,
        private _toastComponent: ToastComponent,
    ) {

        this.fuseConfig.setSettings({
            layout: {
                navigation: 'none',
                toolbar: 'none',
                footer: 'none'
            }
        });
        //Registration form errors
        this.registerFormErrors = {
            firstName: {},
            lastName: {},
            email: {},
            password: {},
            passwordConfirm: {}
        };
        // Add languages
        this.translate.addLangs(['en', 'tr']);

        // Set the default language
        this.translate.setDefaultLang('en');

        // Use a language
        this.translate.use('en');
        this.translationLoader.loadTranslations(navigationEnglish, navigationTurkish);

        this.getAllUserEmail();
    }

    ngOnInit() {

        //Form controls
        this.initializeForm();

    }

    /**Get all users email */
    getAllUserEmail() {

        this.authService.getAllUserEmail()
            .then((res: any) => {

                this.allEmails = res;
                this.initializeForm();

            })
    }

    initializeForm() {

        //Form controls
        this.registerForm = this.formBuilder.group({
            firstName: ['', Validators.required],
            lastName: ['', Validators.required],
            email: ['', [Validators.required, Validators.email, duplicateEmail(this.allEmails)]],
            password: ['', Validators.required],
            passwordConfirm: ['', [Validators.required, confirmPassword]],
            accept: ['', Validators.required]
        });

        this.registerForm.valueChanges.subscribe(() => {
            this.onRegisterFormValuesChanged();
        });
    }

    //On change of form controls
    onRegisterFormValuesChanged() {

        for (const field in this.registerFormErrors) {

            if (!this.registerFormErrors.hasOwnProperty(field)) {
                continue;
            }

            // Clear previous errors
            this.registerFormErrors[field] = {};

            // Get the control
            const control = this.registerForm.get(field);

            if (control && control.dirty && !control.valid) {
                this.registerFormErrors[field] = control.errors;
            }
        }

    }

    // Trim space while typing 
    emailChange() {
        this.registerForm.get('email').setValue(this.registerForm.value.email.trim());
    }

    //Registration
    doRegistration() {

        this.isResults = true;

        //1.call function to get Role Id of Pro
        this.authService.getRoleId(this.spekwoValues.Pro)
            .then(roleId => {

                //2.Save details
                this.userQueryService.REGISTRATION(this.registerForm.value, roleId, '')
                    .subscribe(response => {

                        this.showToast('success');

                        window.localStorage.setItem("userUID", response.data.createUser.user.userId);
                        window.localStorage.setItem("role", this.spekwoValues.Pro);

                        // Set the navigation model
                        this.fuseNavigationService.setNavigationModel(new ProNavigationModel());

                        setTimeout(() => {
                            this.router.navigate(['apps/home']);
                        }, 10);


                    }, () => {
                        this.showToast('failed');
                    })
            })
            .catch(() => {
                this.showToast('failed');
            })

    }

    //Show toast message
    showToast(message) {

        this._toastComponent.showToast(message == 'success' ?
            this.toastMsg.registerSuccess :
            this.toastMsg.registerFailed);
        this.isResults = false;

    }
}

// Check password & confirm password 
function confirmPassword(control: AbstractControl) {

    if (!control.parent || !control) {
        return;
    }

    const password = control.parent.get('password');
    const passwordConfirm = control.parent.get('passwordConfirm');

    if (!password || !passwordConfirm) {
        return;
    }

    if (passwordConfirm.value === '') {
        return;
    }

    if (password.value !== passwordConfirm.value) {
        return {
            passwordsNotMatch: true
        };
    }
}

// Check email is already exist
function duplicateEmail(mails: any) {

    return (control: AbstractControl): { [key: string]: boolean } | null => {

        if (!control.parent || !control) {
            return;
        }

        var matched = _.find(mails, function (o) {
            return o.email.toLowerCase() === control.value.toLowerCase()
        });

        if (matched !== undefined) {
            return { emailExist: true };
        }
        return null;
    };

}



// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/authentication/registration/register-form/register-form.component.ts